import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@ngx-translate/core';
import { AzavistaSharedModule } from '@azavista/components/shared';

class AzavistaSelectedItemsCountComponent {
    constructor() {
        this.count = 0;
    }
    ngOnInit() {
        if (this.data) {
            this.count = this.data.allSelected ? this.data.totalCount : this.data.selectedCount;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaSelectedItemsCountComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.10", type: AzavistaSelectedItemsCountComponent, selector: "azavista-selected-items-count", inputs: { data: "data" }, ngImport: i0, template: "<div *ngIf=\"data\" class=\"aza-selected-items-count-container azavista-selected-items-count-component\">\r\n    <span *ngIf=\"data.title\" class=\"aza-selected-items-count-title\">{{data.title}}</span>\r\n    <span *ngIf=\"!data.title\" class=\"aza-selected-items-count-title\" translate>SELECTED</span>\r\n    <span class=\"aza-selected-items-count-value\">: {{count}}</span>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaSelectedItemsCountComponent, decorators: [{
            type: Component,
            args: [{ selector: 'azavista-selected-items-count', template: "<div *ngIf=\"data\" class=\"aza-selected-items-count-container azavista-selected-items-count-component\">\r\n    <span *ngIf=\"data.title\" class=\"aza-selected-items-count-title\">{{data.title}}</span>\r\n    <span *ngIf=\"!data.title\" class=\"aza-selected-items-count-title\" translate>SELECTED</span>\r\n    <span class=\"aza-selected-items-count-value\">: {{count}}</span>\r\n</div>\r\n" }]
        }], propDecorators: { data: [{
                type: Input
            }] } });

class AzavistaSelectedItemsCountModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaSelectedItemsCountModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.10", ngImport: i0, type: AzavistaSelectedItemsCountModule, declarations: [AzavistaSelectedItemsCountComponent], imports: [AzavistaSharedModule], exports: [AzavistaSelectedItemsCountComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaSelectedItemsCountModule, imports: [AzavistaSharedModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaSelectedItemsCountModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AzavistaSelectedItemsCountComponent
                    ],
                    imports: [AzavistaSharedModule],
                    exports: [AzavistaSelectedItemsCountComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaSelectedItemsCountComponent, AzavistaSelectedItemsCountModule };
